import { getTaxRatesForCategories } from './categories';

export const TaxRatesAPI = {
  getForCategories: getTaxRatesForCategories,
};
